<div class="client-reporting-update-select-campaigns-modal__inline">
    <div class="client-reporting-update-select-campaigns-modal__field modal-field">
        <label class="client-reporting-update-select-campaigns-modal__label modal-label">{{ Platform }}</label>
        <ng-select
            class="client-reporting-update-select-campaigns-modal__select"
            [clearable]="false"
            [searchable]="false"
            [placeholder]="campaignOptions.length == 0 ? ('NO_OPTIONS_FOR_SELECTED_PLATFORM_AND_REPORT_TYPE' | translate) : ('SELECT_PLATFORM_FOR' | translate:{ platform: Platform })"
            [notFoundText]="'NO_OPTIONS_FOR_SELECTED_PLATFORM_AND_REPORT_TYPE' | translate"
            [formControl]="campaignControl">
            <ng-option *ngFor="let option of campaignOptions" [value]="option.value">
                {{ option.text }}
            </ng-option>
        </ng-select>
    </div>

    <button
        type="button"
        class="blue-button client-reporting-update-select-campaigns-modal__button modal-button"
        [disabled]="!campaignControl.value"
        (click)="submitSelection()">
        {{ 'ADD' | translate }}
    </button>
</div>
